import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { getProcesslOg } from './processlog';

@Injectable({
  providedIn: 'root'
})
export class ProcesslogService {

  constructor(private http: HttpClient) { }
  getProcessLogs(data: getProcesslOg) {

    return this.http.post('/api/ProcessRun/GetProcessRuns', data);
  }

  getMissingTrans(p_id,c_id=null) {
    let u = '/api/ProcessRun/MissingTranslationReport?runId=' + p_id ;
    if (c_id) {
      u += '&clientId=' + c_id;
    }
    return this.http.get(u, { observe: 'response', responseType:'blob' });
  }

} ///ProcessRun/MissingTranslationReport ? runId = 1 & clientId=6033
